
const Route = {
    Home: "/",
    Form: "/form",
    About: "/about",
    Feedback: "/feedback",
    Refund: "/refund"
}

export default Route